//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IM from '@/data/im'
import { App_User } from '@/data/user_info'
import EmptyBox from '@/components/views/empty_box'
export default {
    components: {
        EmptyBox
    },
    props: {
        show: Boolean
    },
    data () {
        return {
            page: 1,
            loading: false,
            no_more: false,
            items: [],
            per: 10,
            unread_tim_messages_count: 0,
            scroll_id: 'unread_top'
        }
    },
    watch: {
        show (latest) {
            if (latest) {
                console.error('unread show')
                this.reset()
                this.backTop()
                this.getData()
                this.getCount()
            }
        }
    },
    methods: {
        reset () {
            this.page = 1
            this.items = []
            this.no_more = false
            this.loading = false
        },
        backTop () {
            this.scroll_id = ''
            this.$nextTick(() => {
                this.scroll_id = 'unread_top'
            })
        },
        getCount () {
            App_User.fetchUser()
                .then(({ unread_tim_messages_count }) =>
                    this.unread_tim_messages_count = unread_tim_messages_count
                )
        },
        reachBottom () {
            if (!this.loading && !this.no_more) {
                this.page++
                this.getData()
            }
        },
        async getData () {
            this.loading = true
            try {
                const items = await IM.getUnread({
                    page: this.page,
                    per: this.per
                })
                if (this.page === 1) {
                    this.items = items
                } else {
                    this.items.push(...items)
                }
                this.loading = false
                this.no_more = items.length < this.per
            } catch (err) {
                console.error(err)
            }
        },
        openChat (index) {
            const chat = this.items[index]
            const { id } = chat
            IM.resetChatMapByConversation()
            IM.readChat(id)
            wx.navigateTo({
                url: `/chat_list/chat?session_id=${id}`,
                success: () => {
                    setTimeout(() => {
                        chat.unread_messages_count = 0
                        this.items.splice(index, 1)
                    }, 3000)
                }
            })
        }
    }
}
